import PropTypes from 'prop-types';
import Slider   from 'react-slick';
import SliderArrow from '~/js/components/SliderArrow';

const internals = {
    sliderOptions: {
        lazyLoad: 'progressive',
        autoplay: false,
        centerMode: true,
        centerPadding: '0',
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 100,
        dots: false,
        nextArrow: <SliderArrow classNames="slider-arrow slider-arrow-next"/>,
        prevArrow: <SliderArrow classNames="slider-arrow slider-arrow-prev"/>,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false,
                    dots: true
                }
            },
        ]
    }
};

const ToursItem = (props) => {
    const {
        eventId,
        groupId,
        rstCode,
        tourImages,
        eventName,
        rates,
        description,
        resortName
    } = props;
    const { sliderOptions } = internals;

    let images;
    let displayRate = {
        rate: 0,
        eventRateType: 'Adult'
    };
    let text = description;


    if(tourImages.hasOwnProperty('medium') && tourImages.medium.length > 0) {
        images = (
            <Slider {...sliderOptions}>
                {tourImages.medium.map((image, index)=>{
                    return (
                        <div className="slider-item" key={index}>
                            <div className="equal-heights">
                                <img
                                    src={image}
                                    data-lazy={image}
                                    alt="" />
                            </div>
                        </div>
                    );
                })}
            </Slider>
        );
    }else{
        images = (
            <div className="equal-heights">
                <div className="comingSoon">
                    <i className="ic ic-camera" />
                    <div className="caption">image coming soon</div>
                </div>
            </div>
        );
    }

    rates.map(e=>{
        if (e.rate > displayRate.rate) {
            displayRate = e;
        }
    });

    if(description.length > 200) {
        text = description.substring(0, 200) + '...';
    }

    const goToDetails = (event) => {
        event.preventDefault();
        sessionStorage.setItem('loadResortCode', rstCode);
        sessionStorage.setItem('loadResortName', resortName);
        window.location = `/en/tours/details/?eventID=${eventId}&groupID=${groupId}&rstCode=${rstCode}&resortName=${resortName}`;
    };

    return (
        <div className="item">
            <div className="item-panel">
                <figure>
                    <div className="slider-holder">
                        {images}
                    </div>
                    <figcaption>{eventName}</figcaption>
                </figure>
                <p></p>
                <p>{text}</p>
                <div className="buttons">
                    <a className="details-btn"
                    onClick={(e)=>goToDetails(e)}
                    href="#">View Details</a>
                </div>
            </div>
        </div>
    );
};

ToursItem.propTypes = {
    eventId: PropTypes.number,
    rstCode: PropTypes.string,
    tourImages: PropTypes.object,
    eventName: PropTypes.string,
    rates: PropTypes.array,
    description: PropTypes.string,
    resortName: PropTypes.string
};

ToursItem.defaultProps = {
    eventId: 0,
    rstCode: '',
    tourImages: {},
    eventName: '',
    rates: [],
    description: '',
    resortName: ''
};

export default ToursItem;
